import { render, staticRenderFns } from "./SortTypeSelect.vue?vue&type=template&id=ec791754&"
import script from "./SortTypeSelect.vue?vue&type=script&lang=ts&"
export * from "./SortTypeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports